/* eslint-disable class-methods-use-this */
import BaseFeature from '../../foundation/base/base';
import Swipe from '../../foundation/utilities/swipe';

export class OffCanvas extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;

		this.primaryNav = document.querySelector('.o-primary-nav');
		this.primaryNavTabs = document.querySelector('.o-primary-nav--tabs');
		this.serviceNav = document.querySelector('.o-service-nav');
		this.toolsNav = document.querySelector('.o-header__language');
		this.body = document.querySelector('.u-site');
		this.noActiveLinks = true;
		this.appendNavs();
		this.addEventListener();
		this.activateSwipe();

		this.mainNavsControl();
		this.clusterNav = document.querySelector('[data-ref="off-canvas__clusternav-container"]');


		this.disableLinkTabIndex();
		this.log('OffCanvas');
	}

	addEventListener() {

		this.dom.open.addEventListener('click', e => this.openClick(e));
		this.dom.close.addEventListener('click', e => this.closeClick(e));
		this.dom.mask.addEventListener('click', e => this.closeClick(e));
	}


	appendNavs() {
		this.dom.container.innerHTML = this.dom.container.innerHTML + this.serviceNav.innerHTML + (this.toolsNav ? this.toolsNav.innerHTML : '');
	}

	openClick(e) {
		e.preventDefault();
		this.body.classList.add('u-site--overflow-hidden');
		this.dom.plate.classList.add('o-off-canvas__plate--open');
		this.el.classList.add('o-off-canvas--open');
		this.enableLinkTabIndex();
		// Hide cookies button when mobile menu is open
		document.querySelector('#Coi-Renew').style.zIndex = "unset";
	}

	disableLinkTabIndex() {
		const links = document.querySelectorAll('.o-off-canvas a');
		links.forEach((link) => {
			link.setAttribute('tabindex', -1);
		});
	}

	enableLinkTabIndex() {
		const links = document.querySelectorAll('.o-off-canvas a');
		links.forEach((link) => {
			link.setAttribute('tabindex', 0);
		});
	}

	closeClick(e) {
		e.preventDefault();
		this.resetOffCanvas();
		this.body.classList.remove('u-site--overflow-hidden');
	}

	closeSwipe() {
		this.resetOffCanvas();
	}

	resetOffCanvas() {
		this.dom.plate.classList.remove('o-off-canvas__plate--open');
		this.el.classList.remove('o-off-canvas--open');
	}

	activateSwipe() {
		this.swipe = new Swipe(this.dom.plate);
		this.swipe.onLeft(() => { this.closeSwipe(); });
		this.swipe.onRight(() => false);
		this.swipe.onDown(() => false);
		this.swipe.onUp(() => false);
		this.swipe.run();
	}

	// If we are on a page outside the areas, the primary-nav needs other font colors
	// We add them to both the desktop and off canvas primary nav here
	mainNavsControl() {
		// The English version
		const navItems = this.primaryNav?.querySelectorAll('.m-nav-list__item .a-link');
		for (let i = 0; i < navItems.length; i++) {
			if (navItems[i].classList.contains('a-link--active')) {
				this.noActiveLinks = false;
			}
		}

		// The new Danish version
		const navTabs = this.primaryNav.querySelectorAll('.profile-tab');
		// Hide the primary nav tabs if there are more than 2 tabs 
		if (navTabs.length > 2) {
			this.primaryNavTabs.classList.add('mobile-hidden');
		}
		for (let i = 0; i < navTabs.length; i++) {
			if (navTabs[i].classList.contains('a-link--active')) {
				this.noActiveLinks = false;
			}
			navTabs[i].addEventListener('click', (e) => {
				this.toggleProfilePrimaryNav(e);
			});
		}
		if (this.noActiveLinks === true) {
			document.querySelector('.o-primary-nav .o-primary-nav__list').classList.add('o-primary-nav__list--no-active-links');
		}
	}

	toggleProfilePrimaryNav(navItem) {
		const primaryNavTabs = document.querySelectorAll('.profile-tab');

		for (let i = 0; i < primaryNavTabs.length; i++) {
			primaryNavTabs[i].classList.remove('active-tab');
		}

		navItem.target.parentNode.classList.add('active-tab');
		navItem.target.classList.add('active-link');
	}
}

export default OffCanvas;
